export const RECIEVE_USERS = 'RECIEVE_USERS'

export const recieveUsers = (users) => {
  return {
    type: RECIEVE_USERS,
    users
  }
}


// WEBPACK FOOTER //
// ./src/actions/users.js